import { json, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import httpClient from "../../HTTPService";
import { ToastContainer, toast } from 'react-toastify';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
const ProfileRequesDetailstsView = () => {
    const params = useParams();
    const { id } = params
    const navigate = useNavigate()
    const [editUser, setEditUser] = useState();
    const [UserName, setUserName] = useState('');
    const [isSubmitting, setisSubmitting] = useState(false)
    const [profileData, setProfileData] = useState(null)
    const [Status, setstatus] = useState(1)
    const [commentes, setcommentes] = useState('')
    const [stateObject, setStateobject] = useState({})

    const [dropdoenlistData, setDropdoemlistData] = useState({})
    useEffect(() => {
        getaccountdataDetails()

    }, [])

    useEffect(() => {
        if (dropdoenlistData != null) {
            console.log(dropdoenlistData, 'list data../////')
        }
    }, [dropdoenlistData])
    const getprofileform = async (cat, subcat) => {
        try {
            const result = await httpClient.post('/get-profile-form', {
                category_id: cat,
                sub_category_id: subcat,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data);

            if (result.data.status == true) {
                // console.log(JSON.parse(result?.data?.data), 'details profile data data//>>>>')
                // setProfileData(JSON.parse(result?.data?.data?.form_data))

                result.data?.data?.form_body.forEach(field => {

                    if (field.type === 'select') {
                        getoptonDataDetails(field.option, field.label);
                    }
                });
            }
            if (result.data.status == false) {
                // toast.error(result.data.message)
            }
        } catch (error) {
            // toast.error(error.message)
        } finally {
        }
    }


    const getoptonDataDetails = async (pickerId, fieldName) => {
        console.log(fieldName, 'fie;d name/////')
        if (fieldName == 'District') {
            console.log('selected District', fieldName)
            return;
        }
        try {
            console.log('piofkdsfdslfdf')
            const result = await httpClient.post('/get-options-list', { option: pickerId }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (result.data.status == true) {
                console.log(result?.data?.data, 'option state list data///>>>')
                setDropdoemlistData((prev) => {
                    console.log(fieldName , result?.data?.data, 'previous data/// .......')   
                    return {
                        ...prev,
                        [fieldName == 'state' ? 'State' : fieldName]: result?.data?.data
                    }
                })


            }
            if (result.data.status == false) {

            }

        } catch (error) {
            // toast.error(error.message)
        } finally {

            console.log(dropdoenlistData, 'drop down list data///??>>>>')
        }
    }
    const getaccountdataDetails = async () => {
        try {
            const result = await httpClient.post('/admin/accounts/view', { id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data.status);

            if (result.data.status == true) {
                let filter_stateoption = JSON.parse(result?.data?.data?.form_data)?.filter((option) => option?.label == 'State')
                setStateobject(filter_stateoption)
                console.log(filter_stateoption, 'state option///')
                // if (filter_stateoption == undefined) {

                let district_fetch = await httpClient?.post('/filter-districts', {
                    state_id: filter_stateoption[0]?.value
                },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            'Authorization': `Bearer ${localStorage.getItem('token')}`

                        }
                    }

                )
                setDropdoemlistData((prev) => {

                    return {
                        ...prev,
                        ["District"]: district_fetch?.data?.data
                    }


                })
                // console.log(JSON.parse(result?.data?.data?.form_data), 'distrip data by state///')
                // }

                await getprofileform(result?.data?.data?.category_id, result?.data?.data?.sub_category_id)
                setProfileData(JSON.parse(result?.data?.data?.form_data))
                setcommentes(result?.data?.data?.last_status?.notes)
                setstatus(result?.data?.data?.last_status?.status)


                console.log(JSON.parse(result?.data?.data?.form_data), 'form data..////')

            }
            if (result.data.status == false) {
                toast.error(result.data.message)
            }
        } catch (error) {
            // toast.error(error.message)
        } finally {
            console.log(profileData, 'profile data//lllllllllllllll/>>>')
        }
    }

    // change status....

    const changeStatusAdmin = async (pickerId, fieldName) => {
        try {
            const result = await httpClient.post('/admin/accounts/change-status', {
                id: id,
                status: Status,
                notes: commentes
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (result.data.status == true) {

                toast.success(result?.data?.message)
            }
            if (result.data.status == false) {
                toast.error(result?.data?.message)

            }

        } catch (error) {
            // toast.error(error.message)
        } finally {

            console.log(dropdoenlistData, 'drop down list data///??>>>>')
        }
    }
    return (
        <div className="userEdit">
            <ToastContainer
                autoClose={1000}
            />
            <div className="card">
                <div className="row" id="addDynamicFrm">
                    {
                        profileData?.map((item, index) => {
                            if (item.type === "text") {

                                // console.log("ok")
                                return <div className="col-md-4" key={index}>
                                    <div className="formGroup">
                                        <label className="name-width">{item.label}</label>
                                        <div className="item-list">
                                            <input
                                                disabled
                                                value={item?.value}
                                                type={item.type} placeholder={item.place_holder} name={item.name} />

                                        </div>
                                    </div>
                                </div>
                            }
                            if (item.type == "select") {
                                // console.log('select field item', dropdoenlistData['Bike Brand'])
                                return <div className="col-md-4" key={index}>
                                    <div className="formGroup">
                                        <label>{item.label}  {item?.ismultiple == 1 ? '(Multiple)' : null}</label>
                                        <div className="item-list">
                                            <select
                                                value={(item?.ismultiple !== undefined && item?.ismultiple == 1) ? null : item?.value}
                                                onChange={(e) => console.log('selected value', e.target.value)}
                                            >

                                                {
                                                    item?.ismultiple !== undefined && item?.ismultiple == 1
                                                        ? dropdoenlistData[item?.label?.replace(/\b\w/g, char => char?.toUpperCase())]
                                                            ?.filter((opt) => item?.value?.includes(opt.id)) // ✅ Fixed: check `item.value` not `item`
                                                            ?.map((option) => (
                                                                <option value={option?.id} key={option?.id}>
                                                                    {option?.option_name}
                                                                </option>
                                                            ))
                                                        : dropdoenlistData[item?.label]
                                                            ?.map((option) => (
                                                                <option value={option?.id} key={option?.id}> {/* ✅ key fix */}
                                                                    {option?.option_name}
                                                                </option>
                                                            ))
                                                }

                                                {/* <option></option> */}
                                            </select>

                                        </div>

                                    </div>
                                </div>


                            }
                            if (item.type == "textarea") {
                                return <div className="col-md-4" key={index}>
                                    <div className="formGroup">
                                        <label>{item.label}</label>
                                        <div className="item-list">
                                            <textarea disabled name={item.name} value={item?.value} placeholder={item.place_holder}></textarea>

                                        </div>
                                    </div>
                                </div>
                            }
                            if (item.type == "date") {
                                return <div className="col-md-4" key={index}>
                                    <div className="formGroup">
                                        <label>{item.label}</label>
                                        <div className="item-list">
                                            <input disabled type={item.type} value={item?.value} placeholder={item.place_holder} name={item.name} />

                                        </div>
                                    </div>
                                </div>
                            }
                            // if (item.type == "dob") {
                            //     return <div className="col-md-4" key={index}>
                            //         <div className="formGroup">
                            //             <label>{item.label}</label>
                            //             <div className="item-list">
                            //                 <input type='date' placeholder={item.place_holder} name={item.name} />
                            //                 <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                            //                     <div className="">
                            //                         <p className="icon">X</p>

                            //                     </div>
                            //                 </div>
                            //             </div>
                            //         </div>
                            //     </div>
                            // }
                            if (item.type == "time") {
                                return <div className="col-md-4" key={index}>
                                    <div className="formGroup">
                                        <label>{item.label}</label>
                                        <div className="item-list">
                                            <input disabled type={item.type} value={item?.value} placeholder={item.value} name={item.name} />

                                        </div>
                                    </div>
                                </div>
                            }
                            if (item.type == "file") {
                                return <div className="col-md-9" key={index} style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <h5>Images</h5>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 10,
                                        flexWrap: 'wrap'
                                    }}>
                                        {
                                            item?.imageFileName?.map((item) => {
                                                return (
                                                    <>
                                                        {
                                                            item?.uri && (
                                                                <Zoom>
                                                                    <img
                                                                        alt="That Wanaka Tree, New Zealand by Laura Smetsers"
                                                                        src={item?.uri}
                                                                        width="200"
                                                                    />
                                                                </Zoom>
                                                                // <div style={{
                                                                //     width: 200,
                                                                //     height: 170
                                                                // }}>
                                                                //     <img
                                                                //         style={{
                                                                //             width: '100%',
                                                                //             height: '100%',
                                                                //             objectFit: 'cover'
                                                                //         }}
                                                                //         src={item?.uri} />
                                                                // </div>
                                                            )
                                                        }

                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <div className="formGroup">
                                        <label>{item.label}</label>
                                        <div className="item-list">
                                            <input disabled type={item.type} name={item.name} />

                                        </div>

                                    </div> */}

                                </div>
                            }

                        })

                    }
                </div>

                <div className="row">

                    <div className="col-md-6" >
                        <div className="formGroup">
                            <label>Status</label>
                            <div className="item-list">
                                <select
                                    // disabled={Status == 1 ? true : false}
                                    onChange={(e) => setstatus(e.target?.value)}
                                    value={Status}>
                                    <option value={0}>Pending</option>

                                    <option value={1}>Approve</option>
                                    <option value={2}>Reject</option>
                                    <option value={3}>Block</option>

                                    {/* <option></option> */}
                                </select>

                            </div>

                        </div>
                    </div>
                </div>
                {
                    Status == 2 && (
                        <div className="row">
                            <div className="col-md-6" >
                                <div className="formGroup">
                                    <label>Comment</label>
                                    <div className="item-list">
                                        <textarea
                                            // disabled={Status == 1 ? true : false}

                                            value={commentes}
                                            onChange={(e) => {
                                                setcommentes(e.target?.value)
                                            }}
                                            placeholder="Enter Comment"></textarea>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    Status == 3 && (
                        <div className="row">
                            <div className="col-md-6" >
                                <div className="formGroup">
                                    <label>Comment</label>
                                    <div className="item-list">
                                        <textarea
                                            // disabled={Status == 1 ? true : false}

                                            value={commentes}
                                            onChange={(e) => {
                                                setcommentes(e.target?.value)
                                            }}
                                            placeholder="Enter Comment"></textarea>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                <button
                    // disabled={Status == 1 ? true : false}
                    type='button' onClick={() => { changeStatusAdmin() }} className='searchBtn col-md-2'  >Submit</button>

            </div>
        </div>
    )
}
export default ProfileRequesDetailstsView;